import { connect } from 'react-redux';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { createLoadingSelector } from '@hobs/utils/loading';
import WithAnnexFilter from '@hobs/hocs/WithAnnexFilter';
import WithQuickSearch from '@hobs/hocs/WithQuickSearch';
import WithVisibleColumns from '@hobs/hocs/WithVisibleColumns';
import WithRoles from '@hobs/hocs/WithRoles';
import Dropdown from '@hobs/components/Dropdown';
import {
  createOrder,
  confirmDeliveryForSubmit,
  confirmDelivery
} from '@hobs/actions/orders';
import { queryOData, resetOData, queryXLSOData } from '@hobs/actions/odata';
import { getAnnexes } from '@hobs/actions/annex';
import { getOrderGrid } from '@hobs/actions/gridSelections';
import _Orders from '@hobs/containers/Orders';

import {
  uploadAttachments,
  deleteAttachment,
  clearAttachments
} from '@hobs/actions/attachment';
import { ServiceRequestNavContext } from '@hobs/components/ServiceRequestNavContext';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { SERVICE_REQUEST_NAVIGATION_ORIGIN } from '@hobs/utils/constants';

class Orders extends _Orders {
  getDefaultColumns() {
    const { t } = this.props;
    const data = this._getDefaultColumns();

    if (data.ActivityName) {
      delete data.ActivityName;
    }

    data.OrderNumber = {
      title: t('Order No.'),
      default: true,
      filter: 'numeric',
      visible: true,
      columnMenu: true,
      cell: ({ dataItem }) => (
        <td>
          {dataItem.OrderId && (
            <ServiceRequestNavContext.Consumer>
              {nav => (
                <Link
                  onClick={() => {
                    nav.setPreviousGridPosition(
                      this.state.dataState,
                      window.pageYOffset,
                      this.state.selectedAnnex,
                      this.state.quickSearchValue,
                      SERVICE_REQUEST_NAVIGATION_ORIGIN.Orders,
                      this.state.selectedUnit
                    );
                    nav.setRequestNumber(dataItem.RequestNumber);
                    nav.setOrderId(dataItem.OrderId);
                  }}
                  to={`/order/${dataItem.OrderId}`}
                >
                  {dataItem.OrderNumber}
                </Link>
              )}
            </ServiceRequestNavContext.Consumer>
          )}
        </td>
      )
    };

    data.RequestNumber = {
      title: t('Req. No.'),
      default: true,
      visible: true,
      columnMenu: true,
      width: '90px',
      cell: ({ dataItem }) => (
        <td>
          <ServiceRequestNavContext.Consumer>
            {nav => (
              <Link
                to={`/request-information/${dataItem.ParentServiceRequestId}`}
                onClick={() => {
                  nav.setPreviousPageHistory(history);
                  nav.setPreviousGridPosition(
                    this.state.dataState,
                    window.pageYOffset,
                    this.state.selectedAnnex,
                    this.state.quickSearchValue,
                    SERVICE_REQUEST_NAVIGATION_ORIGIN.Orders,
                    this.state.selectedUnit
                  );
                  nav.setOrderId(dataItem.OrderId);
                  nav.setRequestNumber(dataItem.RequestNumber);
                }}
              >
                {dataItem.RequestNumber}
              </Link>
            )}
          </ServiceRequestNavContext.Consumer>
        </td>
      )
    };

    return data;
  }

  getUnitFilterDropDown() {
    return (
      <div className="orders--heading-actions-filters">
        <ServiceRequestNavContext.Consumer>
          {nav => (
            <Dropdown
              large
              value={this.state.selectedUnit}
              onChange={event => {
                nav.clearSelectedUnit();
                this.handleUnitFilterChange(event.target.value);
              }}
            >
              {this.getUnitOptions(
                this.flattenUnitsTree(this.props.orderGrid.units)
              )}
            </Dropdown>
          )}
        </ServiceRequestNavContext.Consumer>
      </div>
    );
  }
}

const oDataLoading = createLoadingSelector(['OData']);
const mapStateToProps = state => ({
  currentExercise: state.exercise.current,
  forSubmit: state.orders.forSubmit,
  orderGrid: state.gridSelections.orderGrid,
  isLoading: oDataLoading(state),
  oData: state.odata,
  attachments: state.attachment.attachments
});

const mapDispatchToProps = {
  queryOData,
  queryXLSOData,
  getOrderGrid,
  resetOData,
  getAnnexes,
  createOrder,
  confirmDeliveryForSubmit,
  confirmDelivery,
  uploadAttachments,
  deleteAttachment,
  clearAttachments
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslation()(
    withRouter(
      WithVisibleColumns(WithAnnexFilter(WithQuickSearch(WithRoles(Orders))))
    )
  )
);
